var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kd-close-btn",on:{"click":_vm.close}},[_vm._v("\n  "+_vm._s(_vm.GET_TEXT('closeButtonText'))),_c('img',{staticClass:"kd-close-btn__icon",attrs:{"src":_vm.closeIcon}})])}
var staticRenderFns = []

export { render, staticRenderFns }